export const routes = (parentName) => {
  return [
    {
      path: "writer",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Writer`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Writer-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Writer-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Writer-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Writer-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
